export default __webpack_public_path__ + "static/media/trackLogo.7979b44e.svg";